// src/pages/login.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setSessionUser, isAuthed } from "../auth/sessionAuth";
import api from "../services/api";

export default function Login() {
  const navigate = useNavigate();

  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("form-wrapper");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false); // <--- برای غیرفعال کردن دکمه هنگام ارسال

  if (isAuthed()) {
    navigate("/", { replace: true });
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("form-wrapper"); // ریست کردن ارور
    setLoading(true);

    const u = user.trim();

    try {
      // حذف توکن قدیمی از هدر برای جلوگیری از خطای 401 در خود لاگین
      delete api.defaults.headers.common["Authorization"];
      localStorage.removeItem("token");
      // 1. ارسال درخواست لاگین به جنگو
      // جنگو انتظار دارد فیلدها username و password باشند
      const response = await api.post("login/", {
        username: u,
        password: password,
      });

      // 2. دریافت توکن
      const { token } = response.data;

      // 3. ذخیره توکن در حافظه مرورگر (خیلی مهم برای درخواست‌های بعدی)
      localStorage.setItem("token", token);

      // 4. (اختیاری) دریافت اطلاعات پروفایل کاربر برای ذخیره در سشن
      // چون لاگین فقط توکن می‌دهد، یک درخواست به پروفایل می‌زنیم تا نام و عکس را بگیریم
      let userData = {
        username: u,
        role: "کارمند",
        avatar: null,
      };

      try {
        const profileRes = await api.get("profile/");
        // چون ViewSet پروفایل لیست برمی‌گرداند، اولین آیتم را می‌گیریم
        if (profileRes.data && profileRes.data.length > 0) {
            const profile = profileRes.data[0];
            userData.username = profile.user_info.full_name || u; // استفاده از نام کامل
            userData.avatar = profile.avatar;
            // اینجا می‌توانید role را هم اگر در پروفایل اضافه کردید بگیرید
        }
      } catch (profileError) {
        console.warn("پروفایل یافت نشد، استفاده از اطلاعات پیش‌فرض");
      }

      // 5. ذخیره در سشن برنامه
      setSessionUser({
        ...userData,
        token: token, // توکن را هم در سشن نگه می‌داریم
        loginAt: Date.now(),
      });

      // 6. هدایت به داشبورد
      navigate("/", { replace: true });

    } catch (error) {
      console.error(error);
      // نمایش خطا در صورت اشتباه بودن رمز یا مشکل سرور
      setErr("نام کاربری یا رمز عبور اشتباه است.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-main">
      <section>
        <h1>ورود به سامانه</h1>

        <form 
            method="post"  
            className={err === "form-wrapper" ? "form-wrapper" : "form-wrapper error"} 
            onSubmit={onSubmit} 
            autoComplete="off"
        >
          

          <label id="user">
            <span>نام کاربری</span>
            <input
              name="user"
              type="text"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              autoComplete="username"
              disabled={loading}
            />
          </label>

          <label id="password">
            <span>رمز عبور</span>
            <input
              name="password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              disabled={loading}
            />
            <button
              type="button"
              className="show-password"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "مخفی کردن رمز عبور" : "نمایش رمز عبور"}
              disabled={loading}
            >
              {showPassword ? (
                 <svg><use xlinkHref="#openeyeIcon"></use></svg>
              ) : (
                <svg><use xlinkHref="#closeeyeIcon"></use></svg>
              )}
            </button>
          </label>

          <button type="submit" className="form-wrapper-open" disabled={loading}>
            {loading ? "در حال بررسی..." : "ورود"}
          </button>
          
            {/* نمایش متن خطا اگر کلاس error اضافه شده باشد */}
            {err !== "form-wrapper" && <p className="error-msg">{err}</p>}
        </form>
      </section>
    </main>
  );
}